<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <div class="btn-group" role="group" aria-label="basic">
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('PorVencer')">Por Vencer</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('PorCliente')">Por Cliente</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('PorFecha')">Por Fecha</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('Todos')">Todos</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('Cobradas')">Cobradas</button>
                    </div>
                </div>
                <Transition>
                    <div class="form-inline" v-show="BotonMenu.PorFecha">
                        <div class="row form-group">
                            <div class="col-lg-4">
                                <label for="">Fecha Inicial</label>
                                <Datepicker @input="Lista" v-model="Filtro.FechaFiltro.Inicio" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                            </div>
                            <div class="col-lg-4">
                                <label for="">Fecha Final</label>
                                <Datepicker @input="Lista" v-model="Filtro.FechaFiltro.Fin" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                            </div>
                        </div>
                    </div>
                </Transition>
            </template>

            <template v-if="!BotonMenu.PorCliente" slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Empresa</th>
                <th :class="StyleTh">Nombre Comercial</th>
                <th :class="StyleTh">Folio de Nota / Folio Factura</th>
                <th :class="StyleTh">Importe</th>
                <th :class="StyleTh">Fecha de Facturación</th>
                <th :class="StyleTh">Fecha de Pago</th>
                <th :class="StyleTh">Estatus</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>

            <template v-else slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Empresa</th>
                <th :class="StyleTh">Nombre Comercial</th>
                <th :class="StyleTh">RFC</th>
                <th :class="StyleTh">Importe Total</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>

            <template v-if="!BotonMenu.PorCliente" slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.cliente.RazonSocial}}</h6></td>
                    <td><p :class="StyleTd">{{lista.cliente.NombreComercial}}</p></td>
                    <td><p :class="StyleTd">{{lista.Folio}}</p></td>
                    <td><p :class="StyleTd">$ {{lista.TotalPago}}</p></td>
                    <td><p :class="StyleTd">{{lista.nota_ventas!=undefined ? $getCleanDate(lista.nota_ventas.Fecha,false) : $getCleanDate(lista.facturas.FechaTimbrado,false)}}</p></td>
                    <td><p :class="StyleTd">{{$getCleanDate(lista.FechaPago,false)}}</p></td>
                    <td><p :class="StyleTd">{{lista.Estatus != 'Pagado' && EstaVencida(lista.FechaPago) ? 'Vencida' : lista.Estatus}}</p></td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="lista.Estatus != 'Pagado' ? true : false" :pShowBtnDelete="false" :pIsModal="true" :pId="lista.IdCuentaCobrar" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                            <template slot="btnaccion">
                                <CMoreButtonsL>
                                    <template slot="bodyBtnsL">
                                        <template v-if="segurity.MarkAsCollectedBill">
                                            <li @click="CobrarCuenta(lista.IdCuentaCobrar,lista)">
                                                <a class="dropdown-item">
                                                    <div v-show="lista.Estatus=='Pendiente'">
                                                        <i class="far fa-hand-holding-usd"></i> Cobrar
                                                    </div>
                                                    <div v-show="lista.Estatus=='Pagado'">
                                                        <i v-show="lista.Estatus=='Pagado'" class="far fa-eye"></i> Observaciones
                                                    </div>
                                                </a>
                                            </li>
                                        </template>
                                        <template v-if="segurity.DownloadExcelFile">
                                            <li>
                                                <a class="dropdown-item">
                                                    <i class="far fa-file-pdf"></i> Ver Pdf
                                                </a>
                                            </li>
                                        </template>
                                    </template>
                                </CMoreButtonsL>
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
            </template>

            <template v-else slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.RazonSocial}}</h6></td>
                    <td><p :class="StyleTd">{{lista.NombreComercial}}</p></td>
                    <td><p :class="StyleTd">{{lista.RFC}}</p></td>
                    <td><p :class="StyleTd">$ {{lista.TotalPagoCliente.toFixed(2)}}</p></td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false">
                            <template slot="btnaccion">
                                <button class="btn btn-link text-primary px-3 mb-0 mr-1" @click="IrACuentasCliente(lista)">
                                    <i class="fas fa-eye text-primary me-2" aria-hidden="true"></i>Ver Cuentas Por Cobrar
                                </button>
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="5"></CSinRegistros>
            </template>
        </CList>
        
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave" :pListaCuentasCobrar="ListaSimple"></Form>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModalCobrar" :poBtnSave="oBtnSaveCobrar">
			<template slot="Form">
				<FormCobrar :poBtnSave="oBtnSaveCobrar"></FormCobrar>
			</template>
		</CModal>
    </div>
</template>

<script>
import moment from 'moment';
import Calendar from '@/helpers/StaticComboBox.js';
import Form from './Form.vue';
import FormCobrar from './Cobrar.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCuentasCobrar';
const EmitEjecuta2='seccionCobrar';
export default {
    name:'ListaCuentasCobrar',
    props:['pOrigen'],
    components:{Form,FormCobrar},
    data() {
        return {
            ConfigList:{
                Title: 'Cuentas Por Cobrar',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Finanzas',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                Estatus:'',
                FechaFiltro:{
                    Inicio:'',
                    Fin:''
                }
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Cuentas Por Cobrar",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:'lg'
            },
            oBtnSave:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            ConfigModalCobrar:{
                ModalTitle: "Cobrar",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
            },
            oBtnSaveCobrar:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                ShowBtnSave:true
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],
            ListaSimple:[],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Setpicker:Calendar.calendarSettings,
            UrlApi:'',
            Tipo:'',
            Origen:'',
            BotonMenu:{
                PorVencer:true,
                PorCliente:false,
                PorFecha:false,
                Todos:false,
                Cobradas:false
            }
        }
    },
    methods: {
        async Lista(){
            this.ListaArrayRows=[];
            this.UrlApi='/cuentaPorCobrar'
            this.Filtro.Estatus='Pendiente';
            this.Tipo='';
            let params={
                TxtBusqueda:this.Filtro.Nombre,
                Entrada:this.Filtro.Entrada,
                Pag:this.Filtro.Pagina,
                Estatus:this.Filtro.Estatus,
                Tipo:this.Tipo
            }
            if (this.BotonMenu.PorVencer) {
                this.Tipo='PorVencer';
                this.Filtro.Estatus='Pendiente';
                params.Tipo=this.Tipo;
                params.Estatus=this.Filtro.Estatus;
            }
            if (this.BotonMenu.PorCliente) {
                this.UrlApi="/cuentaPorCobrarClientes";
                this.Filtro.Estatus='Pendiente';
                params.Estatus=this.Filtro.Estatus;
            }
            if (this.BotonMenu.PorFecha) {
                params.FechaInicio='';
                params.FechaFin='';
                if (this.Filtro.FechaFiltro.Inicio!='') {
                    let YearInicio=this.Filtro.FechaFiltro.Inicio.getFullYear();
                    let MonthInicio=this.Filtro.FechaFiltro.Inicio.getMonth()+1;
                    let DayInicio=this.Filtro.FechaFiltro.Inicio.getDate();
                    params.FechaInicio=YearInicio+'-'+MonthInicio+'-'+DayInicio;
                }
                if (this.Filtro.FechaFiltro.Fin!='') {
                    let YearFin=this.Filtro.FechaFiltro.Fin.getFullYear();
                    let MonthFin=this.Filtro.FechaFiltro.Fin.getMonth()+1;
                    let DayFin=this.Filtro.FechaFiltro.Fin.getDate();
                    params.FechaFin=YearFin+'-'+MonthFin+'-'+DayFin;
                }

                this.Tipo='PorFecha';
                this.Filtro.Estatus='Pendiente';
                params.Tipo=this.Tipo;
                params.Estatus=this.Filtro.Estatus;
            }
            if (this.BotonMenu.Cobradas) {
                this.Tipo='Cobradas'
                this.Filtro.Estatus='Pagado';
                params.Tipo=this.Tipo;
                params.Estatus=this.Filtro.Estatus;
            }
            this.ConfigList.ShowLoader = true;
            this.$http.get(this.UrlApi,{
                // params:{
                //     TxtBusqueda: this.Filtro.Nombre,
                //     Entrada: this.Filtro.Entrada,
                //     Pag: this.Filtro.Pagina,
                //     Estatus:this.Filtro.Estatus,
                //     FechaInicio:this.Filtro.FechaFiltro.Inicio,
                //     FechaFin:this.Filtro.FechaFiltro.Fin,
                //     Tipo:this.Tipo
                // }
                params:params
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            })
        },
        Regresar(){
            if(this.Origen == 'GraficasCuentas'){
                this.$router.push({name:'graficaCuentas',params:{}})
            } else {
                this.$router.push({name:'panelSubMenus',params:{}});
            }
        },
        GetListaSimple(){
            this.$http.get("/cuentaPorCobrarSimple"
            ).then((res)=>{
                this.ListaSimple=res.data.data;
            })
        },
        IrACuentasCliente(item){
            this.$router.push({name:'cuentaporcobrarcliente',params:{pObjCliente:item}});
        },
        SeleccionLista(index){
            this.Filtro.FechaFiltro.Inicio='';
            this.Filtro.FechaFiltro.Fin='';
            let BotonMenu=this.BotonMenu;
            Object.keys(BotonMenu).forEach(function(key,ind){
				if (key==index) {
					BotonMenu[key]=true;
				}
				else{
					BotonMenu[key]=false;
				}
				// console.log(index)
			});
            this.Lista();
        },
        CobrarCuenta(index,item){
            this.oBtnSaveCobrar.ShowBtnSave=item.Estatus!='Pagado' ?  true : false;
            this.bus.$emit('NewModal_'+this.ConfigModalCobrar.EmitSeccion,index);
        },
        EstaVencida(FechaAEvaluar){
            let formatedDate = FechaAEvaluar.replace(/-/g, "\/");
            let FechaCuenta=new Date(formatedDate);
            let FechaActual=new Date();
            if (FechaActual.getTime()>FechaCuenta.getTime()) {
                return true; 
            }
            else{
                return false;
            }
        }
    },
    created() {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.Origen = Origen;
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('ListaSimple');
        this.bus.$off('EmitReturn');
        this.GetListaSimple();
    },
    mounted() {
        this.Lista();
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('ListaSimple',()=>
        {
            this.GetListaSimple();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>